import { render, staticRenderFns } from "./HandleDetailBySupplier.vue?vue&type=template&id=0d0e452b&scoped=true"
import script from "./HandleDetailBySupplier.vue?vue&type=script&lang=js"
export * from "./HandleDetailBySupplier.vue?vue&type=script&lang=js"
import style0 from "./HandleDetailBySupplier.vue?vue&type=style&index=0&id=0d0e452b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0e452b",
  null
  
)

export default component.exports